import axios, { AxiosRequestConfig } from 'axios';
import { getUserId } from '@/infrastructure/auth';
import { onReqFulfilled } from '@/infrastructure/axios/interceptors/request';
import { onResFulfilled, onResRejected } from '@/infrastructure/axios/interceptors/response';

const config: AxiosRequestConfig = {
  timeout: 100000,
  baseURL: process.env.PROXY === 'true' ? '' : `${location.protocol}//${location.host}`,
  withCredentials: true,
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
  headers: {
    post: {
      ['Content-Type']: 'application/x-www-form-urlencoded',
    },
    common: {
      ['X-Requested-With']: 'XMLHttpRequest',
    },
  },
};

const axiosInstance = axios.create(config);
axiosInstance.interceptors.request.use(onReqFulfilled);
axiosInstance.interceptors.response.use(onResFulfilled, onResRejected);

export const getAxios = () => axiosInstance;

export type TrpcRequestConfig = AxiosRequestConfig & {
  ignoreError?: boolean;
};

/**
 * TRPC Post
 * @param url
 * @param data
 * @param config
 * @constructor
 */
export const TRPCPost = <T = any>(url: string, data: unknown, config?: TrpcRequestConfig): Promise<T> => (
  axiosInstance.post(
    url,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
        'Server-Type': 'trpc',
        user: getUserId(),
      },
      ...config,
    },
  )
);

/**
 * TRPC Get
 * @param url
 * @param config
 * @constructor
 */
export const TRPCGet = <T = any>(url: string, config?: TrpcRequestConfig): Promise<T> => (
  axiosInstance.get(
    url,
    {
      headers: {
        'Content-Type': 'application/json',
        'Server-Type': 'trpc',
        staffName: getUserId(),
      },
      ...config,
    },
  )
);

/**
 * BFF Post
 * @param url
 * @param data
 * @param config
 * @constructor
 */
export const BFFPost = <T = any>(url: string, data: unknown, config?: AxiosRequestConfig): Promise<T> => (
  axiosInstance.post(
    url,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      ...config,
    },
  )
);

/**
 * BFF Get
 * @param url
 * @param config
 * @constructor
 */
export const BFFGet = <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> => (
  axiosInstance.get(
    url,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      ...config,
    },
  )
);

export default axiosInstance;
